import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/inventoryReceivingAuditReport'
import Component from 'components/Reports/InventoryReceivingAuditReport'

export default createListViewContainer({ actions, selectors: selectors.inventoryReceivingAuditReport })(Component)
